import React from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { AIChatBot } from '@/modules/AiAgents/components/Agents/Nugz';
import { CloseChatModal } from '@/modules/AiAgents/components/Agents/Nugz/Modals/CloseChatModal';
import { AIContextProvider } from '@/modules/AiAgents/context/nugzContext/context';
import { AddPropertyField } from '@/modules/settings/property';
import { Typography } from '@/shared/components/atoms';
import { AIButton } from '@/shared/components/atoms/AIButton';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';
// TODO: refactor this
const AddFieldAIButton = () => {
  const { t } = useTranslation(['common', 'onboarding']);
  const { openModal, closeModal } = useModal();
  const [selectedAsset] = useStore((store) => store?.asset);

  return (
    <AIButton
      action={() => {
        closeModal();
        openModal(
          <AIContextProvider>
            <AIChatBot />
          </AIContextProvider>,
          {
            variant: 'full',
            title: (
              <div className='flex w-full items-center justify-between gap-2'>
                <Typography variant='h3' weight='semiBold'>
                  {t('add-your-fields', { ns: 'onboarding' })}
                </Typography>
                <div
                  className='cursor-pointer rounded-xl border-xs border-outline-default px-16 py-2 font-medium text-primary-default'
                  onClick={() => {
                    closeModal();
                    openModal(
                      <AddPropertyField
                        selectedAsset={selectedAsset}
                        onSuccess={() => {
                          toast.success(t('field-added-at-dashboard'));
                        }}
                      />,
                      {
                        variant: 'full',
                        title: (
                          <Typography variant='h2'>
                            {t('fields-and-crops')}
                          </Typography>
                        ),
                      }
                    );
                  }}
                >
                  {t('add-manually')}
                </div>
              </div>
            ),
            onClose: () => {
              openModal(<CloseChatModal />, {
                containerClassName: 'max-w-md',
              });
            },
          }
        );
      }}
      text={t('bulk-upload-ai')}
      width='w-full'
    />
  );
};

export { AddFieldAIButton };
